import { TestimonialPopup } from './TestimonialPopup';

export class TestimonialWidget {
    constructor({
        testimonialsContainerSelector, 
        testimonialSelector, 
        minimizeButtonSelector, 
        rightArrowSelector, 
        leftArrowSelector, 
        playButtonSelector, 
        videoSelector, 
        numberOfTestimonials, 
        delay
    }) {
        this.interval;
        this.testimonialsContainerSelector = testimonialsContainerSelector;
        this.testimonialSelector = testimonialSelector;
        this.videoSelector = videoSelector;
        this.playButtonSelector = playButtonSelector;
        this.testimonials = $(this.testimonialSelector);
        this.minimizeButtonSelector = minimizeButtonSelector;
        this.rightArrowSelector = rightArrowSelector;
        this.leftArrowSelector = leftArrowSelector;
        this.numberOfTestimonials = numberOfTestimonials;
        this.delay = delay;
        this.minimized = false;
        this.currentTestimonial = 0;
        this.apiUrl = window.testimonialData.sameQuestionApiRoute;
        this.init();
    };

    async fetchMinimizedData(testimonialId, questionId) {
        const axiosOptions = {
            params: {
                testimonialId: testimonialId,
                questionId: questionId
            }
        };

        try {
            const response = await axios.get(this.apiUrl, axiosOptions);

            return await response.data;
        } catch (error) {
            console.log(error);
        }
    };

    init() {
        $(window).ready(() => {
            setTimeout(() => {
                $(this.testimonialsContainerSelector).stop().animate({
                    bottom: '20px'
                }, {
                    duration: 500,
                    done: () => {
                        this.setInterval(this.intervalFunction);
                    }
                })
            }, 2000)
        }).on('blur', () => {
            clearInterval(this.interval);
        }).on('focus', () => {
            this.setInterval();
        });

        $(this.testimonialsContainerSelector).find(this.playButtonSelector).each((index, element) => {
            $(element).on('click', () => {
                new TestimonialPopup({
                    testimonialId: $(element).data('testimonial-id'),
                    questionId: $(element).data('question-id'),
                    showViewAllButton: true
                }).openPopup();
            });
        });

        $(this.testimonials).find(this.rightArrowSelector).each((index, element) => {
            $(element).on('click', (event) => {
                this.intervalFunction(false);
                this.setInterval();
            });
        });

        $(this.testimonials).find(this.leftArrowSelector).each((index, element) => {
            $(element).on('click', (event) => {
                this.intervalFunction(true);
                this.setInterval();
            });
        });

        $(this.testimonials).find(this.minimizeButtonSelector).each((index, element) => {
            $(element).on('click', () => {
                this.minimize();
            });
        });
    };

    addClickListeners() {
        this.minimizedPlayButtons = $('.single-testimonial-minimized').find('.play-button');
        this.closeSpeechBubbles = $('.single-testimonial-minimized').find('.close-speech-bubble');

        $(this.closeSpeechBubbles).each((index, element) => {
            $(element).on('click', () => {
                $(this.closeSpeechBubbles).each((index, element) => {
                    $(element).parent().addClass('hide');
                });
            });
        });

        $(this.minimizedPlayButtons).each((index, element) => {
            $(element).on('click', () => {
                new TestimonialPopup({
                    testimonialId: $(element).data('testimonial-id'),
                    questionId: $(element).data('question-id'),
                    showViewAllButton: true
                }).openPopup();
            });
        });  
    };

    removeClassesZ(index, css) {
        return (css.match(/(^|\s)z-ind\S+/g) || []).join(' ');
    };

    removeClassesTab(index, css) {
        return (css.match(/(^|\s)tab-\S+/g) || []).join(' ');
    };

    intervalFunction(reverse = false) {
        this.testimonials = $(this.testimonialSelector);
        const videos = $(this.testimonials).find(this.videoSelector);

        if (reverse) {
            $(videos).each((index, element) => {
                if (index == this.numberOfTestimonials-1) {
                    element.play();
                } else {
                    setTimeout(() => {
                        element.pause();
                        element.currentTime = 0;
                    }, 500)
                }
            });
        } else {
            $(videos).each((index, element) => {
                if (index == 1) {
                    element.play();
                } else {
                    setTimeout(() => {
                        element.pause();
                        element.currentTime = 0;
                    }, 500)
                }
            });
        }

        if (reverse) {
            $(this.testimonials).last().hide();
            $(this.testimonials).last().removeClass(this.removeClassesZ).removeClass(this.removeClassesTab).addClass('z-ind-1').addClass('tab-1');
            $(this.testimonials).last().insertBefore($(this.testimonials).first());
            this.testimonials = $(this.testimonialSelector);
            $(this.testimonials).first().css({'left': '-250px', 'opacity': 0});
            $(this.testimonials).first().show();
            $(this.testimonials).first().stop().animate({
                left: '0px',
                opacity: 1
            }, {
                duration: 500,
                start: () => {
                    $(this.testimonials).eq(1).find(this.minimizeButtonSelector).removeClass('show');
                },
                progress: (animation, progress, remainingMs) => {
                    if (remainingMs <= 400) {
                        $(this.testimonials).each((index, element) => {
                            $(element).removeClass(this.removeClassesZ).removeClass(this.removeClassesTab)
                            .addClass(`z-ind-${index === this.numberOfTestimonials-1 ? this.numberOfTestimonials : index+1}`)
                            .addClass(`tab-${index === this.numberOfTestimonials-1 ? this.numberOfTestimonials : index+1}`);
                        });
                    }
                },
                done: () => {
                    $(this.testimonials).each((index, element) => {
                        $(element).removeAttr('style');
                    });
                }
            });
            if (this.numberOfTestimonials === 3) {
                $(this.testimonials).eq(1).stop().animate({
                    top: '5px'
                }, {
                    duration: 500,
                    queue: false,
                    done: () => {
                        $(this.testimonials).first().find(this.minimizeButtonSelector).addClass('show');
                        $(this.testimonials).each((index, element) => {
                            $(element).removeAttr('style');
                        });

                        this.changeCurrentTestimonialIndex(true);
                    }
                });
                $(this.testimonials).last().stop().animate({
                    top: '10px'
                }, {
                    duration: 500,
                    queue: false,
                    done: () => {
                        $(this.testimonials).first().find(this.minimizeButtonSelector).addClass('show');
                        $(this.testimonials).each((index, element) => {
                            $(element).removeAttr('style');
                        });
                    }
                });
            } else {
                $(this.testimonials).last().stop().animate({
                    top: '5px'
                }, {
                    duration: 500,
                    queue: false,
                    done: () => {
                        $(this.testimonials).first().find(this.minimizeButtonSelector).addClass('show');
                        $(this.testimonials).each((index, element) => {
                            $(element).removeAttr('style');
                        });

                        this.changeCurrentTestimonialIndex(true);
                    }
                });
            }
        } else {
            $(this.testimonials).first().stop().animate({
                left: '-250px',
                top: '0px',
                opacity: 0
            }, {
                duration: 500,
                queue: false,
                progress: (animation, progress, remainingMs) => {
                    if (remainingMs <= 200) {
                        $(this.testimonials).each((index, element) => {
                            $(element).removeClass(`z-ind-${index+1}`).addClass(`z-ind-${index === 0 ? this.numberOfTestimonials : index}`);
                        });
                    }
                    if (remainingMs <= 400) {
                        $(this.testimonials).each((index, element) => {
                            $(element).removeClass(`tab-${index+1}`).addClass(`tab-${index === 0 ? this.numberOfTestimonials : index}`);
                        });
                    }
                },
                start: () => {
                    $(this.testimonials).first().find(this.minimizeButtonSelector).removeClass('show');
                },
                done: () => {
                    $(this.testimonials).first().hide();
                    $(this.testimonials).each((index, element) => {
                        $(element).removeAttr('style');
                    });
                    $(this.testimonials).first().insertAfter($(this.testimonials).last());

                    this.changeCurrentTestimonialIndex();
                }
            });
    
            $(this.testimonials).eq(1).stop().animate({
                top: '0px'
            }, {
                duration: 500,
                queue: false,
                start: () => {

                },
                done: () => {
                    $(this.testimonials).eq(1).find(this.minimizeButtonSelector).addClass('show');
                    $(this.testimonials).each((index, element) => {
                        $(element).removeAttr('style');
                    });
                }
            });
        }
    };

    minimizedIntervalFunction() {
        let active = $('.single-testimonial-minimized.active')

        $(active).stop().animate({
            bottom: '-200px'
        }, {
            duration: 500,
            done: () => {
                this.changeCurrentTestimonialIndex();
                $(active).removeClass('active');
                active = $('.single-testimonial-minimized').eq(this.currentTestimonial);

                $(active).stop().animate({
                    bottom: '20px'
                }, {
                    duration: 500,
                    done: () => {
                        $(active).addClass('active');
                    }
                });
            }
        });
    };

    minimize() {
        let videosData = $('.minimized-testimonials').html();

        $(this.testimonialsContainerSelector).stop().animate({
            bottom: '-400px'
        }, {
            duration: 500,
            done: () => {
                $(this.testimonialsContainerSelector).empty();
                $(this.testimonialsContainerSelector).addClass('minimized');
                $(this.testimonialsContainerSelector).append(videosData);
                $(this.testimonialsContainerSelector).find('.single-testimonial-minimized').eq(this.currentTestimonial).addClass('active');
                this.addClickListeners();
                this.minimized = true;
                this.delay = 4000;
                $(this.testimonialsContainerSelector).stop().animate({
                    bottom: '0px'
                }, {
                    duration: 500,
                    done: () => {
                        this.setInterval(this.minimizedIntervalFunction);
                    }
                })
            }
        });
    };

    setInterval() {
        clearInterval(this.interval);
        
        if (this.minimized) {
            this.interval = setInterval(this.minimizedIntervalFunction.bind(this), this.delay);
        } else {
            this.interval = setInterval(this.intervalFunction.bind(this), this.delay);
        }
    };

    changeCurrentTestimonialIndex(reverse = false) {
        if (reverse) {
            this.currentTestimonial -= 1;
            if (this.currentTestimonial < 0) {
                this.currentTestimonial = this.numberOfTestimonials - 1;
            }
        } else {
            this.currentTestimonial += 1;
            if (this.currentTestimonial > this.numberOfTestimonials - 1) {
                this.currentTestimonial = 0;
            }
        }
    };

};